require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/common/plugins.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/common/plugins.legacy.js
// module id = 626
// module chunks = 31